import { render, staticRenderFns } from "./Charities.vue?vue&type=template&id=0b935df6"
import script from "./Charities.vue?vue&type=script&lang=js"
export * from "./Charities.vue?vue&type=script&lang=js"
import style0 from "./Charities.vue?vue&type=style&index=0&id=0b935df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports